var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import styled from "styled-components";
import MobileOverlayMenu from "shared/lib/components/Common/MobileOverlayMenu";
import colors from "shared/lib/designSystem/colors";
import { Title } from "shared/lib/designSystem";
import ActionSteps from "./ActionSteps";
import { STEPS } from "./types";
import sizes from "shared/lib/designSystem/sizes";
import { CloseIcon } from "shared/lib/assets/icons/icons";
import theme from "shared/lib/designSystem/theme";
import useVaultActionForm from "../../../../hooks/useVaultActionForm";
import { capitalize } from "shared/lib/utils/text";
var ModalNavigation = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 28px;\n  left: 14px;\n  width: calc(100% - 14px);\n  padding-right: 28px;\n"], ["\n  position: absolute;\n  top: 28px;\n  left: 14px;\n  width: calc(100% - 14px);\n  padding-right: 28px;\n"])));
var ArrowBack = styled.i(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  height: 14px;\n  margin-right: 20px;\n"], ["\n  color: ", ";\n  height: 14px;\n  margin-right: 20px;\n"])), colors.primaryText);
var ModalNavigationCloseButton = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: auto;\n"], ["\n  margin-left: auto;\n"])));
var ModalBody = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  box-sizing: border-box;\n  border-radius: 8px;\n  width: ", ";\n  max-width: 450px;\n  min-height: ", ";\n\n  ", "\n\n  @media (max-width: ", "px) {\n    max-height: unset;\n    min-height: unset;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  box-sizing: border-box;\n  border-radius: 8px;\n  width: ", ";\n  max-width: 450px;\n  min-height: ", ";\n\n  ", "\n\n  @media (max-width: ", "px) {\n    max-height: unset;\n    min-height: unset;\n  }\n"])), colors.background.two, function (props) { return (props.variant === "desktop" ? "383px" : "375px"); }, function (props) {
    switch (props.steps) {
        case STEPS.warningStep:
        case STEPS.confirmationStep:
        case STEPS.submittedStep:
            return "unset";
        default:
            return "396px";
    }
}, function (props) {
    return props.variant === "mobile" &&
        props.isFormStep &&
        "\n      background: none;\n      border: none;\n  ";
}, sizes.md);
var modalPadding = 16;
var ModalHeaderWithBackground = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", ";\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  margin-bottom: 24px;\n"], ["\n  background: ", ";\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  margin-bottom: 24px;\n"])), colors.background.one, modalPadding, modalPadding);
var InvisibleModalHeader = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding-top: 32px;\n"], ["\n  padding-top: 32px;\n"])));
var ModalContent = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 100%;\n"])));
var ModalHeaderCloseButton = styled.i(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: ", " ", " ", ";\n  border-radius: 48px;\n  cursor: pointer;\n  position: absolute;\n  right: ", "px;\n  z-index: 10;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: ", " ", " ", ";\n  border-radius: 48px;\n  cursor: pointer;\n  position: absolute;\n  right: ", "px;\n  z-index: 10;\n"])), theme.border.width, theme.border.style, colors.border, modalPadding);
var StepsContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  ", "\n\n  width: 100%;\n  padding-left: ", "px;\n  padding-right: ", "px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  ", "\n\n  width: 100%;\n  padding-left: ", "px;\n  padding-right: ", "px;\n"])), function (props) {
    return props.variant === "desktop" &&
        "\n    height: 100%;\n    ";
}, modalPadding, modalPadding);
var ActionModal = function (_a) {
    var vault = _a.vault, show = _a.show, onClose = _a.onClose, variant = _a.variant;
    var _b = useState(0), step = _b[0], setStep = _b[1];
    var isDesktop = variant === "desktop";
    var vaultActionForm = useVaultActionForm(vault.vaultOption).vaultActionForm;
    var renderModalNavigationItem = useCallback(function () {
        if (isDesktop) {
            return;
        }
        if (step === STEPS.confirmationStep || step === STEPS.submittedStep) {
            return (_jsx(ModalNavigationCloseButton, __assign({ onClick: onClose }, { children: _jsx(CloseIcon, {}, void 0) }), void 0));
        }
        return (_jsxs("div", __assign({ onClick: onClose, role: "button" }, { children: [_jsx(ArrowBack, { className: "fas fa-arrow-left" }, void 0), _jsx(Title, { children: "Back" }, void 0)] }), void 0));
    }, [isDesktop, onClose, step]);
    var renderModalCloseButton = useCallback(function () {
        if (!isDesktop && step !== STEPS.previewStep) {
            return;
        }
        return (_jsx(ModalHeaderCloseButton, __assign({ onClick: onClose }, { children: _jsx(CloseIcon, {}, void 0) }), void 0));
    }, [isDesktop, step, onClose]);
    var renderModalHeader = useCallback(function () {
        var _a;
        if (step === STEPS.previewStep) {
            return (_jsx(InvisibleModalHeader, __assign({ className: "position-relative d-flex align-items-center justify-content-center" }, { children: renderModalCloseButton() }), void 0));
        }
        if (step === STEPS.formStep) {
            return _jsx(_Fragment, {}, void 0);
        }
        var actionWord = capitalize(vaultActionForm.actionType);
        var titles = (_a = {},
            _a[STEPS.warningStep] = "",
            _a[STEPS.formStep] = "",
            _a[STEPS.previewStep] = vaultActionForm.actionType === "migrate" ? "" : actionWord + " Preview",
            _a[STEPS.confirmationStep] = (function () {
                switch (vaultActionForm.actionType) {
                    case "withdraw":
                        if (vaultActionForm.withdrawOption === "standard") {
                            return "Confirm Transaction";
                        }
                        return "Confirm " + actionWord;
                    default:
                        return "Confirm " + actionWord;
                }
            })(),
            _a[STEPS.submittedStep] = (function () {
                switch (vaultActionForm.actionType) {
                    case "withdraw":
                        if (vaultActionForm.withdrawOption === "standard") {
                            return "Initiating Withdrawal";
                        }
                        return "Transaction Submitted";
                    default:
                        return "Transaction Submitted";
                }
            })(),
            _a);
        return (_jsxs(ModalHeaderWithBackground, __assign({ className: "position-relative d-flex align-items-center justify-content-center" }, { children: [_jsx(Title, { children: titles[step] }, void 0), renderModalCloseButton()] }), void 0));
    }, [renderModalCloseButton, step, vaultActionForm]);
    return (_jsx("div", { children: _jsxs(MobileOverlayMenu, __assign({ isMenuOpen: show, onClick: onClose, mountRoot: "div#root", style: {
                display: "flex",
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
            } }, { children: [_jsx(ModalNavigation, __assign({ className: "d-flex flex-row align-items-center" }, { children: renderModalNavigationItem() }), void 0), _jsxs(ModalBody, __assign({ isFormStep: step === STEPS.formStep, variant: variant, steps: step }, { children: [renderModalHeader(), _jsx(ModalContent, __assign({ className: "position-relative" }, { children: _jsx(StepsContainer, __assign({ variant: variant }, { children: _jsx(ActionSteps, { vault: vault, skipToPreview: isDesktop, show: show, onClose: onClose, step: step, onChangeStep: setStep }, void 0) }), void 0) }), void 0)] }), void 0)] }), void 0) }, void 0));
};
export default ActionModal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=ActionModal.js.map